import React from 'react';
import readXlsxFile from 'read-excel-file';
import { getDic } from '../assets/i18n/dictionary';
import { store } from "../store";
import { createConfigModel, convertFormToConfigObject, convertConfigObjectToForm } from '../models/configModel';
import { addNewConfigApi, updateConfigApi, getConfigListByPageIdApi } from '../services/configService';
import { getModalTypeList } from '../services/configService';
import {
    getReturnObject,
    checkIfRegisterExists,
    validateFormControlList,
    verifyIfColtrolRowIsComplete,
    verifyIfTitleRowExists,
} from './utilsImporter';

//Imports de components
import { Loading } from '../components';

const ConfigImporter = (props) => {

    //O método fará a leitura do arquivo
    //Irá verificar se as colunas estão conforme a planilha de exemplo
    //Depois verificará se os dados foram preencidos corretamente
    //Em caso de erro, montar um array do tipo formControlModel para retornar ao usuário onde está o erro
    function importConfigTable(file, groupList, pagesList, screenCodeList, standsList, pavilionsList) {
        return new Promise(async (resolve, reject) => {
            readXlsxFile(file)
                .then(async (rows) => {
                    var _returnVerify = null;

                    //Primeiro, encontrar o index da linha de controle, método duck typing
                    var _controlLineIndex = null;
                    _returnVerify = verifyIfControlRowExists(rows);
                    if (_returnVerify.hasError.error) {
                        reject(_returnVerify.hasError);
                        return;
                    }
                    else {
                        _controlLineIndex = _returnVerify.controlLineIndex;
                    }

                    //Segundo, verificar se alguma coluna foi deletada
                    const _configFormList = convertConfigObjectToForm(createConfigModel(), null, null, null, true);
                    _returnVerify = verifyIfColtrolRowIsComplete(rows[_controlLineIndex], _configFormList);
                    if (_returnVerify.hasError.error) {
                        reject(_returnVerify.hasError);
                        return;
                    }

                    //Terceiro, verificar se a linha de título foi deletada
                    _returnVerify = verifyIfTitleRowExists(rows, _controlLineIndex);
                    if (_returnVerify.hasError.error) {
                        reject(_returnVerify.hasError);
                        return;
                    }

                    //Quarto, converter o array de linhas em um array de objetos do tipo config e formControl
                    _returnVerify = convertRowsInConfigAndFormControlModel(rows, _controlLineIndex, groupList, pagesList, screenCodeList, standsList, pavilionsList);
                    var _configList = _returnVerify.configList;
                    if (_configList === 0) {
                        var _hasError = getReturnObject();
                        _hasError.error = true;
                        _hasError.errorMessage = "Não há dados para cadastrar";
                        reject(_hasError);
                    }

                    //Quinto, validar se os dados estão corretos
                    var _formControlList = _returnVerify.formControlList;
                    _returnVerify = validateFormControlList(_formControlList);
                    if (_returnVerify.error) {
                        reject(_returnVerify);
                        return;
                    }

                    //Sexto, salvar os dados um por um, caso retorne erro, sinalizar quais linhas não foram salvas
                    //Ao salvar, atribuir o id aos elementos salvos para retornar a planilha ao usuário
                    const _newFormControlList = [];
                    var _count = 0;

                    //Verificar se haverá update, se sim, buscar a lista de configurações do evento
                    var _configList = [];
                    var _hasUpdate = false;
                    _formControlList.forEach(item => {
                        var _id = item.find(pr => {
                            return pr.dbReference === "id";
                        });
                        if (_id.value > 0) {
                            _hasUpdate = true;
                        }
                    });
                    if (_hasUpdate) {
                        _configList = await getConfigListByPageIdApi()
                            .catch(err => {
                                _returnVerify.error = true;
                                _returnVerify.errorMessage = "Erro ao atualizar registros, tente novamente mais tarde.";
                            });
                    }

                    do {
                        const item = _formControlList[_count];
                        var _newForm = item;
                        if (!_returnVerify.error) {
                            await saveConfig(item, _configList, _count, _formControlList.length)
                                .then(res => {
                                    item.find((fr, i) => {
                                        if (fr.dbReference === "id") {
                                            _newForm[i].value = res.id;
                                        }
                                    });
                                })
                                .catch(err => {
                                    _returnVerify.error = true;
                                    _returnVerify.errorMessage = "Um ou mais dados não foram salvos, verifique a planilha de retorno.";
                                    item.find((fr, i) => {
                                        if (fr.dbReference === "id") {
                                            _newForm[i].error = true;
                                            _newForm[i].errorMessage = err;
                                        }
                                    });
                                })
                                .finally(() => {
                                    _newFormControlList.push(_newForm);
                                    _count++;
                                });
                        }
                        else {
                            _count = _formControlList.length;
                        }
                    } while (_count < _formControlList.length);

                    if (_count === _formControlList.length) {
                        _returnVerify.data = _newFormControlList;
                        resolve(_returnVerify);
                    }
                })
                .catch(err => {
                    console.log("Erro importConfigTable", err);
                    var _hasError = getReturnObject();
                    _hasError.error = true;
                    _hasError.errorMessage = `${getDic("erro")} ${getDic("ao")} ${getDic("importar")} ${getDic("planilha")}: ${err.toString()}`;
                    reject(_hasError);
                });
        });
    }

    function verifyIfControlRowExists(rows) {
        var _hasError = getReturnObject();
        var _controlLineIndex = null;
        rows.forEach((columns, i) => {
            if (columns.includes("id") && columns.includes("screenId") && columns.includes("typeId")) {
                _controlLineIndex = i;
            }
        });
        if (!_controlLineIndex) {
            _hasError.error = true;
            _hasError.errorMessage = "Linha de controle deletada";
        }
        return { hasError: _hasError, controlLineIndex: _controlLineIndex };
    }

    function convertRowsInConfigAndFormControlModel(rows, controlLineIndex, groupList, pagesList, screenCodeList, standsList, pavilionsList) {
        const _controlRow = rows[controlLineIndex];
        const _configList = [];
        const _formControlList = [];

        //Cria um array de configs com os dados da planilha e um array com validadores de dados
        for (let index = controlLineIndex + 2; index < rows.length; index++) {
            const item = rows[index];
            var _config = createConfigModel();
            const _configReturnObject = [];
            _controlRow.forEach((dbReference, i) => {
                var _value = item[i] && item[i].toString().trim() !== "" ? item[i].toString().trim() : null;
                var _objReturn = validateData(dbReference, _value, groupList, pagesList, screenCodeList, standsList, pavilionsList);
                _config[dbReference] = _value;
                _configReturnObject.push({ dbReference: dbReference, field: _objReturn });
            });
            _configList.push(_config);

            //Atribui valores e campos de erro ao form object
            const _formControlBase = convertConfigObjectToForm(_config, screenCodeList, groupList, null, true);

            const _formControlReturn = [];
            _formControlBase.forEach(obj => {
                var _field = _configReturnObject.find(ret => {
                    return ret.dbReference === obj.dbReference;
                });
                var _newField = obj;
                _newField.error = _field.field.error;
                _newField.errorMessage = _field.field.errorMessage;
                _newField.value = _field.field.data;

                //Verifica se os campos obrigatórios foram preenchidos
                if (_newField.dbReference !== "id" && _newField.required && (_newField.value === null || _newField.value === "")) {
                    _newField.error = true;
                    _newField.errorMessage = getDic("preenchimento-obrigatorio");
                }

                //Verifica se a tela de Stand id 7 possui um id de Stand
                if (_newField.dbReference === "standId" && parseInt(_config.screenId) === 7 && (_newField.value === null || _newField.value === "")) {
                    _newField.error = true;
                    _newField.errorMessage = "As configurações de Stand devem possuir um Stand vinculado";
                }

                //Verifica se a tela de Exposição id 2 possui um id de Pavilhão
                if (_newField.dbReference === "pavilion" && parseInt(_config.screenId) === 2 && (_newField.value === null || _newField.value === "")) {
                    _newField.error = true;
                    _newField.errorMessage = "As configurações de Exposição devem possuir um Pavilhão vinculado";
                }

                _formControlReturn.push(_newField);
            });
            _formControlList.push(_formControlReturn);
        }
        return { formControlList: _formControlList, configList: _configList };
    }

    function validateData(dbReference, data, groupList, pagesList, screenCodeList, standsList, pavilionsList) {
        var _returnObj = getReturnObject();
        switch (dbReference) {
            case "id":
                _returnObj.data = data && parseInt(data) ? parseInt(data) : null;
                break;
            case "screenId":
                _returnObj = checkIfRegisterExists(data, pagesList, _returnObj);
                break;
            case "typeId":
                var _options = getModalTypeList();
                _returnObj = checkIfRegisterExists(data, _options, _returnObj);
                break;
            case "codeScreen":
                _returnObj = checkIfRegisterExists(data, screenCodeList, _returnObj);
                if (!_returnObj.error && parseInt(_returnObj.data)) {
                    var _data = screenCodeList.find(code => {
                        return code.value === parseInt(_returnObj.data);
                    });
                    if (_data) {
                        _returnObj.data = _data.text;
                    }
                }
                break;
            case "standId":
                _returnObj = checkIfRegisterExists(data, standsList, _returnObj);
                break;
            case "pavilion":
                _returnObj = checkIfRegisterExists(data, pavilionsList, _returnObj);
                break;
            case "groupId":
                if (data) {
                    const _dataArray = data.split(",");
                    const _dataReturn = [];
                    _dataArray.forEach(entr => {
                        if (!_returnObj.error && entr && entr.trim() !== "") {
                            _returnObj = checkIfRegisterExists(entr, groupList, _returnObj);

                            if (!_returnObj.error) {
                                _dataReturn.push(_returnObj.data);
                            }
                        }
                    });
                    if (!_returnObj.error) {
                        _returnObj.data = _dataReturn;
                    }
                    else {
                        _returnObj.data = data;
                    }
                }
                else {
                    _returnObj.data = [];
                }
                break;
            case "hasFullScreen":
                _returnObj.data = data === "true" ? true : false;
                break;
            case "initialDate":
                _returnObj = validateDate(data);
                break;
            case "endingDate":
                _returnObj = validateDate(data);
                break;
            default:
                _returnObj.data = data ? data : null;
                break;
        }
        return _returnObj;
    }

    function validateDate(date) {
        var _returnObj = getReturnObject();
        _returnObj.data = date;
        if (date && date !== "") {
            var _date = date;

            if (!_date || _date.length > 16 || _date.length < 16) {
                _returnObj.error = true;
                _returnObj.errorMessage = "Data preenchida em formato incorreto";
            }
            const _array = _date.split("-")
            const _dateArray = _array[0].split("/");
            if (
                !_dateArray[0] || parseInt(_dateArray[0]) < 0 || parseInt(_dateArray[0]) > 31 ||
                !_dateArray[1] || parseInt(_dateArray[1]) < 0 || parseInt(_dateArray[1]) > 12 ||
                !_dateArray[2] || parseInt(_dateArray[2]) < 1900 || parseInt(_dateArray[2]) > 2100
            ) {
                _returnObj.error = true;
                _returnObj.errorMessage = "Data inválida";
            }

            const _hourArray = _array[1].split(":");
            if (
                !_hourArray[0] || parseInt(_hourArray[0]) < 0 || parseInt(_hourArray[0]) > 23 ||
                !_hourArray[1] || parseInt(_hourArray[1]) < 0 || parseInt(_hourArray[1]) > 59
            ) {
                _returnObj.error = true;
                _returnObj.errorMessage = "Hora inválida";
            }

            if (!_returnObj.error) {
                _returnObj.data = `${_dateArray[2]}-${_dateArray[1]}-${_dateArray[0]}T${_hourArray[0]}:${_hourArray[1]}:00-03:00`;
            }
        }
        return _returnObj;
    }

    function saveConfig(formControl, configList, index, totalRegister) {
        return new Promise(async (resolve, reject) => {
            setLoadingMessage(`${getDic("salvando")} ${index + 1} de ${totalRegister}`);
            var _newConfig = convertFormToConfigObject(formControl);

            _newConfig.eventId = store.getState().event.id;

            if (_newConfig.id > 0) {
                //Ao dar update, verificar se a config é do evento correspondente
                var _isConfigFromEvent = configList.find(conf => {
                    return conf.id === _newConfig.id;
                });
                if (_isConfigFromEvent) {
                    await updateConfigApi(_newConfig)
                        .then(res => {
                            _newConfig = res;
                            resolve(_newConfig);
                        })
                        .catch(err => {
                            reject(getDic("erro ", err.toString()));
                        });
                }
                else {
                    reject("ID não pertence a este evento");
                }
            }
            else {
                await addNewConfigApi(_newConfig)
                    .then(res => {
                        _newConfig.id = res.id;
                        resolve(_newConfig);
                    })
                    .catch(err => {
                        reject(getDic("erro ", err.toString()));
                    });
            }
        });
    }

    const importFile = () => {
        setOpenLoading(true);
        setLoadingMessage(getDic("carregando"));

        var _returnObject;
        importConfigTable(props.file, props.groupList, props.pagesList, props.screenCodeList, props.standsList, props.pavilionsList)
            .then(res => {
                _returnObject = res;
            })
            .catch(err => {
                _returnObject = err;
            })
            .finally(() => {
                setOpenLoading(false);
                returnImportFile(_returnObject);
            });
    }

    //Loading control
    const [loadingMessage, setLoadingMessage] = React.useState(getDic("carregando"));
    const [openLoading, setOpenLoading] = React.useState(false);

    React.useEffect(() => {
        importFile();
    }, []);

    const returnImportFile = (returnObject) => {
        if (props.returnImportFile) {
            props.returnImportFile(returnObject);
        }
    }

    return (
        <>
            <Loading open={openLoading} message={loadingMessage} />
        </>
    );
}

export default ConfigImporter;
